/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file AccessView.jsx
 * @author Fernando Ruano
 * @description Access View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * Access View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function AccessView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getAccess } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'SI',
        color: styleGuideColors.baxterBrandTeal
      },

      {
        label: 'NO',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ tiene_accesos }) => tiene_accesos === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label:
                label === 'SI'
                  ? translate('dashboardStaff.register')
                  : translate('dashboardStaff.dontRegister'),
              realLabel: label,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    getAccess({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const { realLabel: classification, cantidad: totalItems } =
      chartData[index];
    history.push(
      `/main/dashboard-detail/access/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F22" loading={!chartData}>
      <DashboardDoughnut
        title={translate('dashboardStaff.access')}
        description={translate('dashboardStaff.accessDesc')}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
AccessView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getAccess: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default AccessView;
